'use client';

import { twMerge } from 'tailwind-merge';
import React from 'react';

export const HoverableIcon = ({
  icon: Icon,
  label,
  isActive,
  onMouseEnter,
  onMouseLeave,
  className,
}: {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  label: string;
  isActive: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  className?: string;
}) => {
  return (
    <div
      className={twMerge('relative cursor-pointer ', className)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="transition-all">
        <div
          className={`flex max-h-5 items-center gap-2 rounded-sm transition-all ${isActive ? 'bg-black/20 px-2' : ''}`}
        >
          <div className="h-5 w-5 text-gray-400 hover:text-white hover:bg-gray-700">
            <Icon className="text-grey-300" />
          </div>
          {isActive && <span className="font-sans text-white whitespace-nowrap">{label}</span>}
        </div>
      </div>
    </div>
  );
};
